import { Routes } from '@angular/router';
import { UserComponent } from '@ponder-features/user/user.component';
import { UserAccountComponent } from '@ponder-features/user/account/user-account.component';
import { UserCollectionComponent } from '@ponder-features/user/collection/user-collection.component';
import { UserDecksComponent } from '@ponder-features/user/decks/user-decks.component';
import { UserStatsComponent } from '@ponder-features/user/stats/user-stats.component';
import { MagicSetComponent } from '@ponder-features/magic/set/magic-set.component';
import { MagicCardComponent } from '@ponder-features/magic/card/magic-card.component';
import { SearchComponent } from '@ponder-features/search/search.component';
import { MagicCollectionComponent } from '@ponder-features/magic/collection/magic-collection.component';
import { MagicDeckComponent } from '@ponder-features/magic/deck/magic-deck.component';
import { DeckComponent } from '@ponder-features/user/decks/deck/deck.component';
import { ItemComponent } from '@ponder-features/item/item.component';
import { UserFriendsComponent } from '@ponder-features/user/friends/user-friends.component';
import { UserHistoryComponent } from '@ponder-features/user/history/user-history.component';
import { MagicBlockComponent } from '@ponder-features/magic/block/magic-block.component';
import { IndexComponnet } from '@ponder-features/index/index.component';
import { AdminControlPanelComponent } from '@ponder-features/admin/admin-control-panel.component';
import { AdminUsersComponent } from '@ponder-features/admin/users/admin-users.component';
import { AdminAlertsComponent } from '@ponder-features/admin/alerts/admin-alerts.component';
import { AdminTasksComponent } from '@ponder-features/admin/tasks/admin-tasks.component';
import { MagicComponent } from '@ponder-features/magic/magic.component';
import { AdminMagicComponent } from '@ponder-features/admin/magic/admin-magic.component';
import { ExportCollectionComponent } from '@ponder-features/user/collection/export/export-collection.component';
import { ImportCollectionComponent } from '@ponder-features/user/collection/import/import-collection.component';
import { SignUpComponent } from '@ponder-features/account/signup.component';
import { SignUpConfirmationComponent } from '@ponder-features/account/signup-confirmation.component';
import { LoginComponent } from '@ponder-features/account/login.component';
import { LoginRecoveryComponent } from '@ponder-features/account/login-recovery.component';
import { NewsComponent } from '@ponder-features/news/news.component';
import { AdminNewsComponent } from '@ponder-features/admin/news/admin-news.component';
import { TermsComponent } from '@ponder-features/general/terms/terms.component';
import { PasswordRecoveryComponent } from '@ponder-features/account/password-recovery.component';
import { LoginRecoveryConfirmationComponent } from '@ponder-features/account/login-recovery-confirmation.component';
import { AboutComponent } from '@ponder-features/general/about/about.component';
import { PageNotFoundComponent } from '@ponder-features/general/404/404.component';
import { UpgradeAccountComponent } from '@ponder-features/account/upgrade/upgrade.component';
import { UpgradeCheckoutComponent } from '@ponder-features/account/upgrade/upgrade-checkout.component';
import { UpgradeCompleteComponent } from '@ponder-features/account/upgrade/upgrade-complete.component';
import { UserAccountGeneralSettingsComponent } from '@ponder-features/user/account/general/user-account-general-settings.component';
import { UserAccountSecuritySettingsComponent } from '@ponder-features/user/account/security/user-account-security-settings.component';
import { UserAccountBillingSettingsComponent } from '@ponder-features/user/account/billing/user-account-billing-setting.component';
import { AdvancedSearchComponent } from '@ponder-features/search/advanced/advanced-search.component';

export const routes: Routes = [ 
    {
        path: "signup",
        component: SignUpComponent,
        title: "Ponder - Account Creation"
    },
    {
        path: "signup/confirmation",
        component: SignUpConfirmationComponent,
        title: "Ponder - Account Confirmation"
    },
    {
        path: "login",
        component: LoginComponent,
        title: "Ponder - Login"
    },
    {
        path: "login/recovery",
        component: LoginRecoveryComponent,
        title: "Ponder - Password Recovery"
    },
    {
        path: "login/recovery/confirmation",
        component: LoginRecoveryConfirmationComponent,
        title: "Ponder - Password Recovery Email"
    },
    {
        path: "login/password-recovery",
        component: PasswordRecoveryComponent,
        title: "Ponder - Password Recovery"
    },
    {
        path: "account/upgrade",
        component: UpgradeAccountComponent,
        title: "Ponder - Account Upgrade"
    },
    {
        path: "account/upgrade/checkout",
        component: UpgradeCheckoutComponent,
        title: "Ponder - Account Upgrade"
    },
    {
        path: "account/upgrade/complete",
        component: UpgradeCompleteComponent,
        title: "Ponder - Account Upgrade"
    },
    {
        path: "news",
        component: NewsComponent,
        title: "Ponder - News"
    },
    {
        path: "search",
        component: SearchComponent,
        title: "Ponder - Search"
    },
    {
        path: "search/advanced",
        component: AdvancedSearchComponent,
        title: "Ponder - Advanced Search"
    },
    {
        path: "user/:username",
        component: UserComponent,
        title: "Ponder - User"
    },
    {
        path: "account",
        component: UserAccountComponent,
        title: "Ponder - User Account",
        children: [
            {
                path: "",
                component: UserAccountGeneralSettingsComponent
            },
            {
                path: "general",
                component: UserAccountGeneralSettingsComponent
            },
            {
                path: "security",
                component: UserAccountSecuritySettingsComponent
            },
            {
                path: "billing",
                component: UserAccountBillingSettingsComponent
            }
        ]
    },
    {
        path: "user/:username/friends",
        component: UserFriendsComponent,
        title: "Ponder - User Friends"
    },
    {
        path: "user/:username/stats",
        component: UserStatsComponent,
        title: "Ponder - User Stats"
    },
    {
        path: "user/:username/collection",
        component: UserCollectionComponent,
        title: "Ponder - User Collection"
    },
    {
        path: "user/:username/collection/export",
        component: ExportCollectionComponent,
        title: "Ponder - Export Collection"
    },
    {
        path: "user/:username/collection/import",
        component: ImportCollectionComponent,
        title: "Ponder - Import Collection"
    },
    {
        path: "user/:username/collection/magic",
        component: MagicCollectionComponent,
        title: "Ponder - User Magic Collection"
    },
    {
        path: "user/:username/decks",
        component: UserDecksComponent,
        title: "Ponder - User Decks"
    },
    {
        path: "user/:username/decks/:deckId",
        component: DeckComponent,
        title: "Ponder - User Deck"
    },
    {
        path: "user/:username/decks/magic/:deck_id",
        component: MagicDeckComponent,
        title: "Ponder - User Magic Deck"
    },
    {
        path: "history",
        component: UserHistoryComponent,
        title: "Ponder - User Logs"
    },
    {
        path: "magic/card/:setCode/:setIndex/:cardName",
        component: MagicCardComponent,
        title: "Ponder - Magic - Card"
    },
    {
        path: "magic/card/:setCode/:setIndex",
        component: MagicCardComponent,
        title: "Ponder - Magic - Card"
    },
    {
        path: "magic/set/:setCode",
        component: MagicSetComponent,
        title: "Ponder - Magic - Set"
    },
    {
        path: "magic/block/:blockCode",
        component: MagicBlockComponent,
        title: "Ponder - Magic - Block"
    },
    {
        path: "magic",
        component: MagicComponent,
        title: "Ponder - Magic"
    },
    {
        path: "item/:itemId",
        component: ItemComponent,
        title: "Ponder"
    },
    {
        path: "acp",
        component: AdminControlPanelComponent,
        title: "Ponder - Admin",
        children: [
            {
                path: "alerts",
                component: AdminAlertsComponent,
                title: "Ponder - Alerts (Admin)"
            },
            {
                path: "news",
                component: AdminNewsComponent,
                title: "Ponder - News (Admin)"
            },
            {
                path: "tasks",
                component: AdminTasksComponent,
                title: "Ponder - Tasks (Admin)"
            },
            {
                path: "users",
                component: AdminUsersComponent,
                title: "Ponder - Users (Admin)"
            },
            {
                path: "magic",
                component: AdminMagicComponent,
                title: "Ponder - Magic (Admin)"
            }
        ]
    },
    {
        path: "about",
        component: AboutComponent,
        title: "About Ponder"
    },
    {
        path: "terms",
        component: TermsComponent,
        title: "Ponder - Terms of Service"
    },
    {
        path: "",
        component: IndexComponnet,
        title: "Ponder"
    },
    { 
        path: "**", 
        component: PageNotFoundComponent,
        title: "Ponder - 404 Page Not Found"
    }
];